export default __webpack_public_path__ + "static/media/ic-fert-form.57641897.svg";